import * as formats from "../../../../common/formats";

require('select2');
require('tempusdominus-bootstrap-4');

var baseDatepickerOpts = {
	locale: 'ja',
	dayViewHeaderFormat: 'YYYY年 M月',
	format: 'YYYY/MM/DD',
};

// 新規契約作成
$(() => {
    if (document.getElementById('client-contract-form') != null) {
		setupLabels();
		setupPartners();
        setupPartnerType();
        setupCompanyUsers();
        deleteFiles();
        deleteFilesByNew();
        cancelFiles();
        addFiles();
        setupReportType();
        changePartnerType();
        selectPartnerType();

		$('.date .datepicker').datetimepicker(baseDatepickerOpts);
		setupMonthlyDatepicker();
		setupMonthlyConditionTable();
		setupAdditionalCostTable();
		setupRelatedContractsList();
		setupDetailSettingCollapse();

        $('#common_modal').on('show.bs.modal', function (event) {
            var el = $(event.relatedTarget);
            var title = el.data('title').length? el.data('title'): "";
            var message = el.data('message').length? el.data('message'): "";
            var exec = el.data('exec').length? el.data('exec'): "はい";
            var cxl = el.data('cxl').length? el.data('cxl'): "キャンセル";
            var modal = $(this);
            modal.find('.modal-title').text(title);
            modal.find('.modal-body').text(message);
            modal.find('.modal-exec').text(exec);
            modal.find('.modal-cxl').text(cxl);

			$('.modal-exec').off('click');
            $('.modal-exec').on('click', function(event) {
				var t = event.currentTarget.innerText;
				if (t == '途中保存する') {
					// 途中保存のフラグを立てる
					$('#form').append('<input name="save" type="hidden" value="true" />');
				} else {
					// 保存データ破棄のフラグを立てる
					$('#form').append('<input name="remove" type="hidden" value="true" />');
				}
                $('.js-data-price').each(function(i, e) {
                    $(e).val(formats.convertNum($(e).val()));
                });
                $('.js-data-hour').each(function(i, e) {
                    $(e).val(formats.convertNum($(e).val()));
                });
				$('.js-data-1000sep').each(function(i, e) {
					$(e).val(formats.convertNum($(e).val()));
				});
                $('#form').submit();
            });
        })
	}
});

/**
 * ファイル削除処理
 */
function deleteFiles() {
    // 見た目上消すだけ、実際の削除は保存の後
    $(document).on("click", '.js-file-delete', function(e) {
        var id = $(this).data('id');
        $('#form').append('<input name="deleteFile[]" type="hidden" value="'+ id + '" />');
        $('#file_'+id).remove();
        if ($('#files').children('div').length < 3) {
            $('#inputFiles').show();
        }
    });
}

/**
 * 新規作成時のファイル削除
 */
function deleteFilesByNew()
{
    // 本当に消す
    $(document).on("click", '.js-file-delete-new', function(e) {
        var id = $(this).data('id');
        var path = $(this).data('name');
        $('#form').append('<input name="deleteFile[]" type="hidden" value="'+ path + '" />');
        $('#file_'+id).remove();
    });
}

/**
 * ファイル追加キャンセル処理
 */
function cancelFiles() {
    $(document).on("click", '.js-file-cancel', function(e) {
        var id = $(this).data('id');
        $('#input_'+id).remove();
        $(this).parent().remove();
    });
}

/**
 * ファイル追加
 */
function addFiles() {
    $(document).ready(function(e){
        if ($('#files').children('div').length >= 3) {
            $('#inputFiles').hide();
        }
    });

    $(document).on("input", '.js-file-add', function(e) {
        // 最大アップロードファイルサイズ
        const maxFileSize = 10485760;
        const maxFileSizeStr = '10MB';
        // 既にアップロードエラーメッセージが表示されている場合は一旦削除
        $('#file-errors').find('.upload-error').remove();
        $('#file').removeClass('form-control').removeClass('is-invalid');

        // アップロードファイルの取得
        let fileEntity = $(this)[0].files[0];
		let error = '';
        if (fileEntity === undefined) {
            error = 'ファイルのアップロードに失敗しました。再度お試しください。';
        } else if (fileEntity.size > maxFileSize) {
            error = 'アップロードファイルのサイズが最大値を超えました。最大アップロードサイズ：' + maxFileSizeStr;
        }

        if (error.length > 0) {
            $('#file-errors').append('<span class="invalid-feedback upload-error" role="alert"><strong>' + error + '</strong>');
            $('#file').addClass('form-control').addClass('is-invalid');
            $(this).val("");
            return;
        }
        var file_name = $(this).prop('files')[0].name;
        var file_id = $(this).data('id') + 1;

        $(this).css('display', 'none');
        $(this).attr('id', 'input_' + file_id);

        $('#inputFiles').append('<input id="file" type="file" class="js-file-add form-control-file border rounded w-75" name="file[]" data-id="'+ file_id +'">');

        var new_file = $('<div class="col-3" id="'+ file_id +'">').appendTo('#files');
        new_file.append('<span class="fas fa-file" id="cheng-status-span"></span>');
        new_file.append(file_name);
        new_file.append('<a class="js-file-cancel font-xxs" data-id="' + file_id + '"><i class="fas fa-times text-info"></i></a>');

        if ($('#files').children('div').length >= 3) {
            $('#inputFiles').hide();
        }
    });
    $(document).on('click', '.js-file-cancel', function(){
        // 表示も削除
        $(this).parent().remove();
    });
}

// パートナー一覧
function setupPartners() {
    setupSelect2('.js-partners', '/client/contract/new/findGenuinePartners', 'ユーザーを選択して下さい', templateUserResultItem, templateUserSelectionItem);
}

// 企業ユーザー一覧
function setupCompanyUsers() {
	setupSelect2('.js-client', '/client/contract/new/findCompanyUsers', 'ユーザーを選択して下さい', templateUserResultItem, templateUserSelectionItem);
	setupSelect2('.js-viewable-users', '/client/contract/new/findCompanyUsers', 'ユーザーを選択して下さい', templateUserResultItem, templateUserSelectionItem);
	updateWorkflowUser();
}

// ラベル
function setupLabels() {
	$('#labels').select2({
		tags: true,
		placeholder: 'ラベルを選択して下さい',
		dropdownAutoWidth: true,
		allowClear: true,
		width: 'resolve',
	});
	var params = $('#labels').data('init');
	if (params) {
		// paramsが1件の場合、数値になってしまうのでtoString()する
		$('#labels').val(params.toString().split(',')).trigger('change');
	}
}

function setupSelect2(selector, url, placeholder, templateResult, templateSelection, local_data = null) {
	var element = $(selector);

    if (element.data('local')) {
        var options = {
            tags: true,
            placeholder: placeholder,
            dropdownAutoWidth: true,
            width: 'resolve',
            allowClear: true,
            data: element.data('local'),
            templateResult: templateResult,
            templateSelection: templateSelection
        };
    } else {
        var options = {
            tags: true,
            placeholder: placeholder,
            dropdownAutoWidth: true,
            width: 'resolve',
            allowClear: true,
            ajax: {
                type: 'POST',
                async: true,
                url: url,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: function (params) {
                    var query = {
                        search: params.term,
                    }
                    return query;
                },
                minimumInputLength: 2,
                delay: 200,
                cache: true,
                processResults: function(data) {
                    let target = this.$element;
                    if (data.results.length == 0 && target.val()) {
                        // 選択中の場合で検索結果が無ければ、選択中の要素を追加する
                        data.results = [{ id:target.val(), text:target.find('option:selected').text() }]
                    }
                    return data;
                },
            },
            templateResult: templateResult,
            templateSelection: templateSelection
        }
    }
	var select2 = element.select2(options);
	var initItem = element.data('init');
	if (initItem) {
		// 初期値を設定
		if (initItem.length) {
			initItem.forEach(function(item) {
				var opt = new Option(templateUserSelectionItem(item).html(), item.id, false, false);
				element.append(opt);
			});
			element.val(initItem.map((item)=>item.id)).trigger('change');
		} else {
			var opt = new Option(templateUserSelectionItem(initItem).html(), initItem.id, false, false);
			element.append(opt);
			element.val(initItem.id).trigger('change');
		}
	}
    // 未選択等のエラー時
    var isInvalid = element.hasClass('is-invalid');
    if (isInvalid) {
        select2.data('select2').$container.addClass('is-invalid');
    }
}

// ユーザー選択のアイテムテンプレート
function templateUserResultItem(data) {
	if (!data.id || data.loding) {
		// group or Searching...
		return $(`<span><b>${data.text}</b></span>`);
	}

	let view = null;
	if (data.avatar_path) {
		view = $(`<span><img src='/${data.avatar_path}' class="rounded-circle avatar-21"> ${data.text}</span>`);
	} else {
		view = $(`<span>${data.text}</span>`);
	}
	return view;
}

// ユーザー選択の選択時表示テンプレート
function templateUserSelectionItem(data) {
	if (!data.id || data.loding) {
		// placeholder or Searching...
		return $(`<span>${data.text}</span>`);
	}

	let view = null;
    if (data.avatar_path) {
        view = $(`<span><img src='/${data.avatar_path}' class="rounded-circle avatar-21"> ${data.text}</span>`);
    } else {
        view = $(`<span>${data.text}</span>`);
    }
    // PTN選択用
    if (data.pic !== undefined && document.querySelector('.js-partners-message') !== undefined) {
        if (data.pic) {
            if (document.querySelector('.js-partners-message').hasChildNodes() === false) {
                $('.js-partners-message').append(
                    $('<span class="js-effective-contract-message invalid-feedback" role="alert">\
                選択されたユーザーの契約はすでに存在している可能性があります。ホームの契約を確認ください。\
                </span>')
                );
            }
        } else if(document.querySelector('.js-partners-message').hasChildNodes() === true) {
            document.querySelector('.js-partners-message').removeChild(
                document.querySelector('.js-effective-contract-message')
            );
        }
    }
	return view;
}

// ユーザー選択の選択時表示テンプレート(社名付)
function templateCompanyUserSelectionItem(data) {
	if (!data.id || data.loding) {
		// placeholder or Searching...
		return $(`<span>${data.text}</span>`);
	}

	let view = null;
	if (data.avatar_path) {
		view = $(`<span><img src='/${data.avatar_path}' class="rounded-circle avatar-21"> ${data.company_name??''} ${data.text}</span>`);
	} else {
		view = $(`<span>${data.company_name??''} ${data.text}</span>`);
	}
	return view;
}


// 除外リスト取得
function getExclusions(selector) {
	// 更新するdata属性はjQueryでは取得できないためネイティブJSで取得する
	let ele = document.querySelector(selector);
	let json = ele? ele.getAttribute('data-exclusions'): null;
	return json? JSON.parse(json): [];
}

// 除外リスト設定
function setExclusions(selector, val) {
	let ele = document.querySelector(selector);
	if (ele) {
		let json = ele.setAttribute('data-exclusions', JSON.stringify(val));
	}
}

// ワークフロー更新時、閲覧可能ユーザーの除外ユーザーを更新する
function updateWorkflowUser() {
	let exclusions = [];
	let selector = '.js-viewable-users';
	setExclusions(selector, exclusions);
	let element = $(selector);
	let values = element.val();
	if (values) {
		values = values.map(i=>parseInt(i));
		values = values.filter(id => !exclusions.includes(id));
		element.val(values).trigger('change');
	}
}

// 指定したセレクタの値から、表示用セレクタの状態を制御する
function setupWorkflowUser(targetSelector, showSelector, exclusions) {
	let target = $(targetSelector);
	let show = $(showSelector);
	let id = target.val();
	if (id) {
		// 除外リストに追加し、選択中のアイテムを表示用セレクタに表示
		exclusions.push(parseInt(id));
		let html = $(targetSelector + ' option:selected').html();
		$(showSelector + ' > div').eq(0).html(html);
		show.removeClass('d-none');
	} else {
		// 非表示に変更
		show.addClass('d-none');
	}
}


// datepicker構築
function setupMonthlyDatepicker() {
	var monthOpts = {
		...baseDatepickerOpts,
		viewMode: 'years',
		format: 'YYYY/MM',
	};
	$('.month .datepicker').datetimepicker(monthOpts);

    $('.datepicker').blur(function(event) {
        // 契約期間
        var term_start = $('#termStart').val();
        var term_end = $('#termEnd').val();
        // 月別設定
        let month = [];
        $('input[name="month[]"]').each(function(index, element) {
            month.push(element.value);
        });
        // 初期費用など
        let term_additional_month = [];
        $('input[name="additionalMonth[]"]').each(function(index, element) {
            term_additional_month.push(element.value);
        });

        // datepickerをフォーカスアウト時に閉じる
        $('.datepicker').datetimepicker('hide');

        /**
         * datepickerの仕様で、hide時にセットした値が消えてしまう(HTML上では、valueが設定されたまま)
         * 事前に値を確保し、hide後に設定し直す
         * */
        $('input[name="additionalMonth[]"]').each(function(index, element) {
            $('#additionalMonth' + index).val(term_additional_month[index]);
        });
        $('input[name="month[]"]').each(function(index, element) {
            $('#month' + index).val(month[index]);
        });
        $('.termStart').val(term_start);
        $('#termEnd').val(term_end);
    });
}

// 月別条件テーブル構築
function setupMonthlyConditionTable() {
	$(document).on("click", '.js-remove-monthly-condition', function(e) {
		e.preventDefault();
		let tr = $('.js-monthly-table-body .js-data-row');
		if (tr.length > 1) {
			$(this).closest('.js-data-row').remove();
		} else {
			// 最後の1行の時は値のみクリアする
			$(this).closest('.js-data-row').find('input').each(function(i, element) {
				$(element).val('');
			});
		}
	});
	$(document).on("click", '.js-add-monthly-condition', function(e) {
		e.preventDefault();
		let template = $('.js-monthly-table-body .js-data-row').last();
		let row = template.clone();
		let id = row.data('id') + 1;
		row.attr('data-id', id);
		$(row.find('input').get(0)).attr('id', 'month' + id);
		row.find('.js-datepicker-set-target').data('target', '#month' + id);
		$($(row).find('input')).removeClass('is-invalid');
		$('.js-monthly-table-body').append(row);
		setupMonthlyDatepicker();
	});
}

// 追加費用テーブル構築
function setupAdditionalCostTable() {
	$(document).on("click", '.js-remove-additional-cost', function(e) {
		e.preventDefault();
		let tr = $('.js-additional-cost-table-body .js-data-row');
		if (tr.length > 1) {
			$(this).closest('.js-data-row').remove();
		} else {
			// 最後の1行の時は値のみクリアする
			$(this).closest('.js-data-row').find('input').each(function(i, element) {
				$(element).val('');
			});
		}
	});
	$(document).on("click", '.js-add-additional-cost', function(e) {
		e.preventDefault();
		let template = $('.js-additional-cost-table-body .js-data-row').last();
		let row = template.clone();
		let id = row.data('id') + 1;
		row.attr('data-id', id);
		$(row.find('input').get(0)).attr('id', 'additionalMonth' + id);
		row.find('.js-datepicker-set-target').data('target', '#additionalMonth' + id);
		$($(row).find('input')).removeClass('is-invalid');
		row.find('input').each(function(){
			$(this).val('');
		});
		$('.js-additional-cost-table-body').append(row);
		setupMonthlyDatepicker();
	});
}

// 関連契約リスト構築
function setupRelatedContractsList() {
	var element = $('.js-select-contract');
	setupContractSelector(element, '/client/contract/new/findContracts');

	const relatedContracts = $('#relatedContracts').val();
	if (relatedContracts) {
		const template = $('#related-list-item');
		relatedContracts.split(',').forEach((param) => {
			let data = param.split(':');
			const item = createRelatedItem(data[0], data[1], data[2]);
			$('.js-related-list').append(item);
		});
	}

	$('.js-add-related-contract').on('click', function(e) {
		$.ajax({
			url: '/client/contract/new/getContract',
			type: 'POST',
			data: { id: $('#contractSelector').val() },
			dataType: 'json',
			timespan: 1000
		}).done(function(data, textStatus, jqXHR) {
			if (data.id) {
				const item = createRelatedItem(data.id, data.no, data.name);
				$('.js-related-list').append(item);
				let values = $('#relatedContracts').val().split(',');
				const result = values.find(item => item.split(':')[0] == data.id);
				if (!result) {
					values.push(data.id + ':' + data.no + ':' + data.name);
					$('#relatedContracts').val(values.join(','));
				}
			}
		}).fail(function(jqXHR, textStatus, errorThrown ) {
		}).always(function(){
		});
	});

	$(document).on("click", '.js-remove-related-contract', function(e) {
		e.preventDefault();
		let target = $(this).closest('.js-contract-item');
		if (target.length) {
			let id = target.data('id');
			let values = $('#relatedContracts').val().split(',');
			const results = values.filter(item => item.indexOf(id + ':') != 0);
			$('#relatedContracts').val(results.join(','));
			target.remove();
		}
	});
}

// 関連契約アイテム作成
function setupContractSelector(element, url) {
	element.select2({
		tags: false,
		placeholder: '契約名を入力して下さい',
		dropdownAutoWidth: true,
		width: 'resolve',
		allowClear: true,
		ajax: {
			type: 'POST',
			async: true,
            url: url,
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
			},
			data: function (params){
				var query = {
					search: params.term,
				}
				return query;
			},
			minimumInputLength: 2,
			delay: 200,
			cache: true,
			processResults: function(data) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            id: item.id,
                            text: item.name,
                        }
                    })
                }
            }
		}
	});
	var params = element.data('init');
	if (params) {
		let values = [];
		params.split(',').filter(item => {
			let val = item.split(':');
			var opt = new Option(val[1], val[0], false, false);
			element.append(opt);
			values.push(val[0]);
		});
		element.val(values).trigger('change');
	}
}

// 関連契約アイテム作成
function createRelatedItem(id, no, name) {
	const content = $('#related-list-item')[0].content;
	const fragment = document.createDocumentFragment();
	let clone = document.importNode(content, true);
	let item = $('.js-contract-item', clone);
	item.attr('data-id', id);
	item.children('.js-contract-no').text(no);
	item.children('.js-contract-name').text(name);
	fragment.appendChild(clone);
	return fragment;
}

// 請求形式
function setupReportType() {
	$('.js-reportType').on('change', function(e) {
		updateAdvisoryBlock();
	});
	updateAdvisoryBlock();
}

function updateAdvisoryBlock() {
	let reportType = $('.js-reportType').val();
	switch (reportType) {
		case '1':
			$('.advisory-collapse').show();
			$('.monthly_setting-collapse').show();
			$('.base_reword_word').text('基本契約月額');
			break;
		case '2':
			$('.advisory-collapse').hide();
			$('.monthly_setting-collapse').show();
			$('.base_reword_word').text('基本契約月額');
			break;
		case '3':
			$('.advisory-collapse').hide();
			$('.monthly_setting-collapse').hide();
			$('.base_reword_word').text('基本時給');
			break;
	}
}

function changePartnerType() {
    $('select[name="partner"]').on("change", function(e) {
        if ($(this).val() !== null && $(this).val().length > 0) {
            $('#partnerType').prop('checked', true);
            selectPartnerType();
        } else if ($(this).val() === null) {
            if (document.querySelector('.js-effective-contract-message') !== undefined) {
                document.querySelector('.js-partners-message').removeChild(document.querySelector('.js-effective-contract-message'));
            }
        }
    });
    $('input[name="invitePartner"]').on("change", function(e) {
        if ($(this).val().length > 0) {
            $('#partnerTypeInvite').prop('checked', true);
            selectPartnerType();
        }
    });
}

function setupPartnerType() {
    if ($('input[name="partnerType"]:checked').val() === '0') {
        $('select[name="partner"]').prop('disabled', false);
        $('input[name="invitePartner"]').prop('disabled', true);
        $('input[name="invitePartnerUserName"]').prop('disabled', true);
    } else {
        $('select[name="partner"]').prop('disabled', true);
        $('input[name="invitePartner"]').prop('disabled', false);
        $('input[name="invitePartnerUserName"]').prop('disabled', false);
    }
}

function selectPartnerType() {
    $('input[name="partnerType"]').on('change', function(e) {
        if ($(this).val() === '0') {
            $('select[name="partner"]').prop('disabled', false);
            $('input[name="invitePartner"]').prop('disabled', true);
            $('input[name="invitePartnerUserName"]').prop('disabled', true);
        } else {
            $('select[name="partner"]').prop('disabled', true);
            $('input[name="invitePartner"]').prop('disabled', false);
            $('input[name="invitePartnerUserName"]').prop('disabled', false);
        }
    });
}

// 折り畳みできる詳細設定関連のセットアップ
function setupDetailSettingCollapse() {
	let monthlySettingSection = $('#monthly-setting-section');
	monthlySettingSection.on('show.bs.collapse', function() {
		$('input[name="monthlySettingExpanded"]').val('1');
	});
	monthlySettingSection.on('hide.bs.collapse', function() {
		$('input[name="monthlySettingExpanded"]').val('');
	});

	let additionalCostSettingSection = $('#additional-cost-setting-section');
	additionalCostSettingSection.on('show.bs.collapse', function() {
		$('input[name="additionalCostSettingExpanded"]').val('1');
	});
	additionalCostSettingSection.on('hide.bs.collapse', function() {
		$('input[name="additionalCostSettingExpanded"]').val('');
	});

	let otherSettingSection = $('#other-setting-section');
	otherSettingSection.on('show.bs.collapse', function() {
		$('input[name="otherSettingExpanded"]').val('1');
	});
	otherSettingSection.on('hide.bs.collapse', function() {
		$('input[name="otherSettingExpanded"]').val('');
	});
}